// @flow
import _ from 'lodash';
import Cookies from 'js-cookie';

import { ContextBarContent, DEFAULT_CONTENT_PRIORITY } from './content.js';
import CookieWarningtemplate from '../templates/content-cookie-warning.html';

export const COOKIE_NAME = 'cookie-notification-disabled';
const COOKIE_EXPIRE_PERIOD = 182;
export class ContentCookieWarning extends ContextBarContent {
	constructor (options) {
		options = _.defaultsDeep(options || {},
			{
				name: 'cookie-warning',
				above: ['default'],
			}
		);
		super(options);

		this.priority = DEFAULT_CONTENT_PRIORITY + 1;

		this.template = {
			html: CookieWarningtemplate(),
			data: this,
		};
	}

	beforeRemove = () => {
		this._setCookie();
	}

	_setCookie = () => {
		Cookies.set(COOKIE_NAME, true, { expires: COOKIE_EXPIRE_PERIOD, path: '/' });
	}
}